jQuery(document).ready(function($) {

    //Second Section Define
    $('body section').each(function() {
        var index = $(this).index();
        if(index == 2) {
            $(this).attr('id', 'scroll-target-section');
        }
    });

    $('body').on('click', function() {
        $('.modal .video-banner').get(0).pause();
    });

     $('.modal-body').on('click', function(e) {
        e.stopPropagation();
    });

     $('.close-video-popup').on('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        $('.modal .video-banner').get(0).pause();
         $('#videoPopup').modal('toggle');
     });

    //Owl
     $("#about-owl").owlCarousel({
        items: 1,
        nav: false,
        stagePadding: 75,
        margin: 24,
        rtl:true,
        slideTransition: 'linear',
        smartSpeed: 1000,
        autoplayTimeout: 5000,
        responsive:{
            500:{
                rtl:true,
                stagePadding: 150,
            },
            990:{
                rtl:false,
                stagePadding: 70,
            },
        }
      });

     $("#about-owl-reverse").owlCarousel({
        items: 1,
        nav: false,
        stagePadding: 75,
        margin: 24,
        rtl:true,
        slideTransition: 'linear',
        smartSpeed: 1000,
        autoplayTimeout: 5000,
        responsive:{
            500:{
                rtl:true,
                stagePadding: 150,
            },
            990:{
                rtl:true,
                stagePadding: 70,
            },
        }
      });

     var owlBen = $("#benefits-owl");
     owlBen.owlCarousel({
        items: 1,
        nav: false,
        stagePadding: 32,
        margin: 30,
        center: true,
        loop: true,
        autoplay: true,
        slideTransition: 'linear',
        smartSpeed: 1000,
        autoplayTimeout: 5000,
        responsive:{
            500:{
                items: 2,
                stagePadding: 50,
            },
            990:{
                items: 2,
                stagePadding: 200,
            },
            1000:{
                items: 3,
            },
            1200:{
                items: 4,
            },
            1900:{
                items: 4,
            },
            2200:{
                items: 5,
              },
        }
      });

     var owlCul = $("#culture-owl");
     owlCul.owlCarousel({
        items: 1,
        nav: true,
        margin: 10,
        loop: true,
        slideTransition: 'linear',
        smartSpeed: 1000,
        autoplayTimeout: 5000,
      });

      $("#supports-owl").owlCarousel({
        items: 1,
        nav: false,
        stagePadding: 85,
        margin: 24,
        loop: true,
        slideTransition: 'linear',
        smartSpeed: 1000,
        autoplayTimeout: 5000,
      });

      var videoOwl = $("#video-owl");
      $("#video-owl").owlCarousel({
        items: 1,
        autoWidth: false,
        nav: false,
        stagePadding: 0,
        margin: 24,
        loop: true,
        slideTransition: 'linear',
        smartSpeed: 1000,
        autoplayTimeout: 5000,
        responsive:{
            990:{
                items: 1,
                autoWidth: false,
                nav: false,
                stagePadding: 100,
                margin: 24,
                loop: true,
            },
            1200:{
                items: 2,
                autoWidth: false,
                nav: false,
                stagePadding: 50,
                margin: 24,
                loop: true,
            },
            1300:{
                items: 1,
                autoWidth: true,
            },
        }
      });

      $("#events-owl").owlCarousel({
        items: 1,
        nav: false,
        stagePadding: 0,
        margin: 24,
        loop: true,
        slideTransition: 'linear',
        smartSpeed: 1000,
        autoplayTimeout: 5000,
        responsive:{
            500:{
                items: 2,
                nav: false,
                stagePadding: 50,
                margin: 24,
                loop: true,
            },
            990:{
                items: 2,
                nav: false,
                stagePadding: 150,
                margin: 24,
                loop: true,
            },
        }
      });

      $("#big-owl").owlCarousel({
        items: 1,
        nav: false,
        stagePadding: 0,
        margin: 24,
        loop: true,
        slideTransition: 'linear',
        smartSpeed: 1000,
        autoplayTimeout: 5000,
        responsive:{
            500:{
                items: 1,
                nav: false,
                stagePadding: 100,
                margin: 24,
                loop: true,
            },
            1000:{
                items: 1,
                nav: false,
                stagePadding: 200,
                margin: 24,
                loop: true,
            },
            1400:{
                items: 1,
                nav: false,
                stagePadding: 400,
                margin: 24,
                loop: true,
            },
        }
      });

    /*if($("#benefits-owl").length) {
        $("#benefits-owl .owl-item").css('height', $("#benefits-owl .owl-stage").height() + 'px');
     }

     if($("#culture-owl").length) {
        $("#culture-owl .owl-item").css('height', $("#culture-owl .owl-stage").height() + 'px');
     }*/

     videoOwl.on('drag.owl.carousel', function(e) {
        $('.values-video-wrap', this).removeAttr("data-bs-toggle");
    });

     videoOwl.on('changed.owl.carousel', function(e) {
        $('.values-video-wrap', this).attr("data-bs-toggle", 'modal');
    });

     if($("#benefits-owl").length) {
        var slideIndex = $('#benefits-owl .center').index() - 2;
        $('.benefits-slider-number').html('0' + slideIndex);
     }

    owlBen.on('changed.owl.carousel', function(e) {
        var index = (e.property.value - Math.ceil(e.item.count / 2)) % e.item.count || 0;
        var indexProp = index + 1;
        $('.benefits-slider-number').html('0' + indexProp);
    });

    owlCul.on('changed.owl.carousel', function(e) {
        var index = (e.property.value - Math.ceil(e.item.count / 2)) % e.item.count || 0;
        var indexProp = index + 1;
        $('.culture-slider-number').html('0' + indexProp);
    })

     if($('#benefits-owl').length) {
        var position = $('.benefits-owl .center').offset();
        var width = $('.benefits-owl .center').width();
        var properPos = position.left + width - 50;
        $('.benefits-slider-number').css('left', properPos);
     }

     if($('.video-section .baloon-image').length) {
        var position = $('.values-video-wrap').offset();
        var width = $('.values-video-wrap').width();
        var properPos = position.left - width - 50;
        $('.video-section .baloon-image').css('left', properPos);
     }

     if($('.video-section-side .baloon-image').length) {
        var position = $('.values-video-wrap').offset();
        var width = $('.values-video-wrap').width();
        var properPos = position.left + width + 100;
        $('.video-section .baloon-image').css('left', properPos);
     }

     //Mobile menu
     $('.hamburger').on('click', function() {
        $('body').toggleClass('overflow');
        $(this).toggleClass('active');
        $('.mobile-menu').toggle();
     });

     $('.form-row-inner').each(function() {
        var widthLabel = $('label', this).width();
        var width = widthLabel + 30;
        $('.wpcf7-form-control-wrap', this).css('padding-left', width);
     });

     //Input file label names/format/size file
    $('.file-input').bind('change',function() {
        var filenameUncropped = $(this).val().replace(/C:\\fakepath\\/i, '');
        var filename = filenameUncropped.substring(0, filenameUncropped.indexOf("."));
        var labelText = $(this).parent().find('label').html();
        var filesize = this.files[0].size;
        var fileformat = $(this).val().split('.').pop();
        if(filename.length > 1) {
            $(this).parent().parent().find('.file-label').html(filename + '.' + fileformat);
        }
        else {
            $(this).parent().parent().find('.file-label').html('Choose File');
        }
    });

    //Thankyou form
       document.addEventListener("wpcf7mailsent", function( event ) {
        window.setTimeout(function(){
            $('.join-form-section .form-wrap .wpcf7').hide();
            $('.thankyou-popup').css('display', 'flex');
            $('.file-label').html('Choose File');
            $('.thankyou-popup').delay(3000).fadeOut();
            $('.join-form-section .form-wrap .wpcf7').delay(3000).fadeIn();
        }, 0);
    }, false);

    //Video preview
    var videoWrap = $('.values-video-wrap');
    var video = $('.video-banner');

    var previewTimeout = null;

    function stopPreview() {
      video.currentTime = 0;
      video.playbackRate = 1;
      video.pause();
    }

    videoWrap.on('mouseenter', function() {
        $('.video-banner', this).muted = true;
        $('.video-banner', this).currentTime = 1;
        $('.video-banner', this).playbackRate = 0.5;
        $('.video-banner', this).get(0).play();
        previewTimeout = setTimeout(stopPreview, 8000);
    });

    videoWrap.on('mouseleave', function() {
        clearTimeout(previewTimeout);
        previewTimeout = null;
        $('.video-banner', this).currentTime = 0;
        $('.video-banner', this).playbackRate = 1;
        $('.video-banner', this).get(0).pause();
    });

    $('.values-video__play').on('click', function(e) {
        e.preventDefault();
    });
});